export default __webpack_public_path__ + "static/media/computer.ee0a0d54.svg";